import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import SortData from '../models/sort_data'
import { API_ENDPOINT_BUSINESS_TX, SORT_ORDER_DESC } from '../config'
import { buildUrl } from '../utils/helpers'

export const BUSINESSES_REQUEST = 'BUSINESSES_REQUEST'
export const BUSINESSES_SUCCESS = 'BUSINESSES_SUCCESS'
export const BUSINESSES_FAILURE = 'BUSINESSES_FAILURE'

function buildBusinessTxDataUrl(
  page = 1,
  limit = 25,
  businessType = null,
  search,
  status,
  parentBusinesses,
  sortBy = null,
  order = null
) {
  let queryParams = businessType ? { business_type: businessType } : {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (search) {
    queryParams = { ...queryParams, ...{ search } }
  }

  if (status) {
    queryParams = { ...queryParams, ...{ status } }
  }

  if (parentBusinesses) {
    queryParams = { ...queryParams, ...{ parent_business__id: parentBusinesses } }
  }

  if (sortBy) {
    if (order === SORT_ORDER_DESC) {
      sortBy = '-' + sortBy
    }
    queryParams = { ...queryParams, ...{ ordering: sortBy } }
  }
  return buildUrl(`${API_ENDPOINT_BUSINESS_TX}/`, { ...queryParams })
}

export function fetchBusinesses(
  page = null,
  limit,
  businessType = 'investor',
  search,
  status,
  parentBusinesses,
  sortData
) {
  let field, order
  if (sortData && sortData instanceof SortData) {
    field = sortData.getField()
    order = sortData.getOrder()
  }

  return {
    [CALL_API]: {
      endpoint: buildBusinessTxDataUrl(page, limit, businessType, search, status, parentBusinesses, field, order),
      types: [BUSINESSES_REQUEST, BUSINESSES_SUCCESS, BUSINESSES_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
